import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <GoogleOAuthProvider clientId="1099266644156-67q2hh9l6jjgt13lh9dhui59uhbes4la.apps.googleusercontent.com">
    </GoogleOAuthProvider> */}
    <App />
  </React.StrictMode>
);